import React from "react";
import TableView from "../../../../../Basic/TableView";

var RequestUserFailedTable = function RequestUserFailedTable(props) {
  var data = props.data,
      prefix = props.prefix,
      translate = props.translate;
  var columns = [{
    id: "Email",
    isFilterable: false,
    isSortable: false,
    disableHeaderSort: true,
    Header: translate('SFxAccountSettingsUserEmailLabel'),
    headerStyle: {
      minWidth: 170
    },
    style: {
      minWidth: 170
    },
    minWidth: 170,
    Cell: function Cell(row) {
      var email = row.original.email;
      return /*#__PURE__*/React.createElement("span", null, email);
    }
  }, {
    id: "Name",
    isFilterable: false,
    isSortable: false,
    disableHeaderSort: true,
    Header: translate('SFxAccountSettingsUserTableNameTitle'),
    headerStyle: {
      minWidth: 170
    },
    style: {
      minWidth: 170
    },
    minWidth: 170,
    Cell: function Cell(row) {
      var _row$original = row.original,
          surname = _row$original.surname,
          givenName = _row$original.givenName;
      return /*#__PURE__*/React.createElement("span", null, "".concat(givenName, " ").concat(surname));
    }
  }];
  return /*#__PURE__*/React.createElement(TableView, {
    className: "".concat(prefix, "-user-modal-table"),
    data: data,
    columns: columns,
    showPagination: false
  });
};

export default RequestUserFailedTable;